module.exports = __webpack_public_path__ + "img/[嘿哈].cbb41ce3.svg";